import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    minHeight: '100vh'
  },
  background: {
    height: "100%",
    width: "100%",
    alignItems: "center",
  },
  content: {
    flex: 1,
    justifyContent: "flex-end",

    padding: 32,
    paddingVertical: 52,
  },
  logo: {
    justifyContent: "center",
    alignItems: "center",
    height: "30vh",
  },
  actionContainer: {
    height: "40vh",
    paddingBottom: 20
  },
  passwordContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    position: "relative"
  },
  eyeButton: {
    padding: 10,
    zIndex: 100,
    position: "absolute",
    top: -10,
    right: 10
  },
  actionButton: {
    padding: 10,
    width: 280,
    height: 60,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 50,
    backgroundColor: "#FFF",
    position: "relative",
  },
  actionButtonText: {
    textTransform: "uppercase",
    letterSpacing: 1,
    color: "#1FBFB5",
  },
  loginForm: {
  },
  input: {
    position: "relative",
    padding: 10,
    paddingLeft: 30,
    width: "100%",
    maxWidth: 280,
    height: 60,
    borderRadius: 50,
    backgroundColor: "#FFF",
    opacity: 0.6,
    marginBottom: 40,
    alignSelf: 'center'
  },
  forgotPassword: {
    marginTop: 40,
  },
  forgotPasswordText: {
    color: "#fff",
    textAlign: "center",
  },
  header: {
    marginTop: 20,
    padding: 15,
    marginLeft: 'auto',
  },
  closeButton: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  keepLogged: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 5,
    marginBottom: 10
  },
  checkboxContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    paddingBottom: 20
  },
  checkbox: {
    alignSelf: "center",
  },
  checkboxLabelContainer: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  checkboxLabel: {
    margin: 8,
    color: "#fff",
    alignItems: "center",
    justifyContent: 'center',
    flexDirection: "row"
  },
  termsLink: {
    color: 'white',
    textDecorationLine: 'underline'
  },
  loginPinContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  loginPinInner: {
    width: "90%",
    alignItems: "center",
  },
});

export default styles;
